import TrailLoader from './TrailLoader';

export default TrailLoader;
